/**
 * Safely serialize JSON for embedding inside a <script type="application/ld+json"> tag.
 * Escapes characters that would otherwise allow HTML injection or break parsing.
 */
export const safeJsonLd = (obj) =>
  JSON.stringify(obj)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
